import React from "react";
import { useNavigate } from "react-router-dom";

const domains = [
  { title: "Custom Software Development", desc: "Tailored software solutions to meet your unique business requirements.", id: "software-dev" },
  { title: "Mobile App Development", desc: "Android and iOS apps built natively .", id: "mobile-dev" },
  { title: "Cybersecurity Solutions", desc: "Protect your digital assets with our comprehensive cybersecurity services.", id: "cybersecurity" },
  { title: "Automation & Manual Testing", desc: "Ensure software quality with robust automated and manual testing processes.", id: "testing" },
  { title: "IT Training & Upskilling", desc: "Gain in-demand skills with our professional IT training and career upskilling programs.", id: "training" },
  { title: "Digital Marketing", desc: "Boost your online visibility and engagement with strategic digital marketing campaigns.", id: "marketing" },
];

export default function ExpertiseCards() {
  const navigate = useNavigate();

  const handleCardClick = (id) => {
    navigate(`/what-we-do#${id}`);
  };

  return (
    <div className="container py-5">
      <h3 className="text-center mb-5">What We Do</h3>
      <div className="row g-4">
        {domains.map((domain, index) => (
          <div className="col-md-4 d-flex" key={index}>
            <div
              className="card h-100 w-100 shadow rounded border-0"
              style={{
                transition: "transform 0.3s",
                backgroundColor: "#f8f9fa",
                cursor: "pointer",
                position: "relative",
              }}
              onClick={() => handleCardClick(domain.id)}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0px)")}
            >
              <div className="card-body d-flex flex-column">
                <h5 className="card-title fw-semibold text-dark">{domain.title}</h5>
                <p className="card-text text-secondary">{domain.desc}</p>
                <div className="mt-auto text-end text-primary fw-bold">
                  Learn More &rarr;
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
